import { render, staticRenderFns } from "./Tariffs.vue?vue&type=template&id=e6dd9d44&"
import script from "./Tariffs.vue?vue&type=script&lang=ts&"
export * from "./Tariffs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports